var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_32756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21798 10H17.5513C17.7723 10 17.9843 10.0878 18.1406 10.2441C18.2968 10.4004 18.3846 10.6123 18.3846 10.8333V13.3333C18.3846 14.2174 18.0335 15.0652 17.4083 15.6904C16.7832 16.3155 15.9354 16.6667 15.0513 16.6667H6.71798C5.83392 16.6667 4.98608 16.3155 4.36095 15.6904C3.73583 15.0652 3.38464 14.2174 3.38464 13.3333V10.8333C3.38464 10.6123 3.47244 10.4004 3.62872 10.2441C3.785 10.0878 3.99696 10 4.21798 10V10Z",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88464 10V4.16667C5.88464 3.72464 6.06024 3.30072 6.3728 2.98816C6.68536 2.67559 7.10928 2.5 7.55131 2.5H10.0513V4.375",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21796 17.5L5.05129 16.25",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5513 17.5L16.718 16.25",
    stroke: "#1DA1F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_32756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.884644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.14b737a1bee1b44b0fa4b1eada089a04.svg";
export { ForwardRef as ReactComponent };